import styled from 'styled-components'
import IlabProjects from '../IlabProjects'

const PageContainer = styled.main`
	margin: 2vh 2vw;
`

export default function ILabProjectsPage() {
	return (
		<PageContainer>
			<IlabProjects />
		</PageContainer>
	)
}
